<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-btn icon @click="goBack">
								<v-icon>mdi-arrow-left</v-icon>
							</v-btn>
							<v-toolbar-title>Affiliate Dashboard - {{ partnerName }}</v-toolbar-title>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense hide-details @click:append="getSearch" @keyup.enter="getSearch" />
								</v-col>
								<v-col cols="12" md="5">
									<v-menu v-model="dateMenu" :close-on-content-click="false" offset-y min-width="290px">
										<template #activator="{ on, attrs }">
											<v-text-field
												:value="computedDateRange"
												label="Periodo spedizione"
												outlined
												dense
												hide-details
												clearable
												readonly
												prepend-inner-icon="mdi-calendar-range"
												v-bind="attrs"
												v-on="on"
												@click:clear="resetDateRangeToCurrentMonth"
											/>
										</template>
										<v-date-picker v-model="settings.filters.created_at" range @change="onDateRangeChange" />
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<div class="d-flex align-center" style="gap: 8px">
										<v-btn color="primary" outlined @click="dateMenu = true">
											<v-icon left>mdi-calendar-range</v-icon>
											Seleziona periodo
										</v-btn>
										<v-btn text @click="resetDateRangeToCurrentMonth">Mese corrente</v-btn>
									</div>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table :hide-default-header="mobileCards" :class="{ 'table-cards': mobileCards }" :headers="headers" :items="filteredOrders" :options.sync="settings.options" class="elevation-0" :footer-props="{ 'items-per-page-options': listSize }">
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="affiliate-order-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.OrderID ? `Ordine ${item.OrderID}` : 'Ordine'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-chip small class="mr-2" :color="item.payed ? 'success' : 'warning'" :dark="item.payed">
														{{ item.payed ? 'Pagata' : 'Da pagare' }}
													</v-chip>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td>{{ item.OrderID }}</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
										<td>{{ item.ShippedTime | moment('DD/MM/YYYY HH:mm:ss') }}</td>
										<td>{{ formatAmount(item.Total) }}</td>
										<td>{{ formatAmount(item.commission) }}</td>
										<td>
											<v-chip small :color="item.payed ? 'success' : 'warning'" :dark="item.payed">
												payed {{ item.payed ? 'true' : 'false' }}
											</v-chip>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import { listReturnLocation } from '@/components/core/list/listReturn';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import KeyValueCard from '@/components/core/KeyValueCard.vue';

export default {
	name: 'AffiliateDashboardOrders',
	components: {
		KeyValueCard,
	},
	data() {
		return {
			dateMenu: false,
			listSize: [15, 25, 50, 100],
			searchfield: '',
			settings: {
				search: '',
				filters: {
					created_at: [],
				},
				options: {
					sortBy: ['ShippedTime'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			headers: [
				{ text: 'OrderID', value: 'OrderID', sortable: true },
				{ text: 'created_At', value: 'created_at', sortable: true },
				{ text: 'ShippedTime', value: 'ShippedTime', sortable: true },
				{ text: 'Total', value: 'Total', sortable: true },
				{ text: 'commission', value: 'commission', sortable: true },
				{ text: 'payed', value: 'payed', sortable: true },
			],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getItem: 'partners/getItem',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		partnerName() {
			const name = [this.getItem?.name, this.getItem?.lastname].filter(Boolean).join(' ');
			return name || '';
		},
		computedDateRange() {
			if (this.settings.filters.created_at.length > 0) {
				return this.settings.filters.created_at.map(value => moment(value).format('DD/MM/YYYY')).join(' ~ ');
			}
			return '';
		},
		orders() {
			if (!Array.isArray(this.getItem?.orders)) {
				return [];
			}

			return this.getItem.orders.map(entry => ({
				_id: entry._id || entry.order?._id,
				OrderID: entry.order?.OrderID || '',
				created_at: entry.order?.created_at || '',
				ShippedTime: entry.order?.ShippedTime || '',
				Total: entry.order?.Total || 0,
				commission: entry.commission || 0,
				payed: !!entry.payed,
			}));
		},
		filteredOrders() {
			let orders = this.orders.filter(item => this.isInSelectedPeriod(item.ShippedTime));

			if (this.settings.search && this.settings.search.length >= 2) {
				const search = this.settings.search.toLowerCase();
				orders = orders.filter(item => String(item.OrderID || '').toLowerCase().includes(search));
			}

			return orders;
		},
	},
	async created() {
		this.initDateRange();
		await this.getDataFromApi();
	},
	methods: {
		...mapActions({
			fetchPartnerDetail: 'partners/getDetail',
		}),
		async getDataFromApi() {
			if (!this.$route.params.id) {
				return;
			}

			const result = await this.fetchPartnerDetail({ _id: this.$route.params.id });
			if (!result) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante il caricamento del partner';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
		getSearch() {
			this.settings.search = this.searchfield && this.searchfield.length >= 2 ? this.searchfield : '';
			this.settings.options.page = 1;
		},
		initDateRange() {
			if (this.isValidDate(this.$route.query.from) && this.isValidDate(this.$route.query.to)) {
				this.settings.filters.created_at = [this.$route.query.from, this.$route.query.to].sort();
				return;
			}

			this.resetDateRangeToCurrentMonth(false);
		},
		getCurrentMonthRange() {
			const today = new Date();
			const start = new Date(today.getFullYear(), today.getMonth(), 1);
			const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);

			return [
				`${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`,
				`${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`,
			];
		},
		resetDateRangeToCurrentMonth() {
			this.settings.filters.created_at = this.getCurrentMonthRange();
			this.settings.options.page = 1;
			this.dateMenu = false;
		},
		onDateRangeChange(value) {
			if (!Array.isArray(value) || value.length === 0) {
				this.resetDateRangeToCurrentMonth();
				return;
			}

			this.settings.filters.created_at = [...value].sort();
			if (this.settings.filters.created_at.length === 2) {
				this.dateMenu = false;
				this.settings.options.page = 1;
			}
		},
		isInSelectedPeriod(value) {
			if (!value || !Array.isArray(this.settings.filters.created_at) || this.settings.filters.created_at.length !== 2) {
				return false;
			}

			const [from, to] = this.settings.filters.created_at;
			const start = moment(from).startOf('day');
			const end = moment(to).endOf('day');
			const shipped = moment(value);

			return shipped.isValid() && shipped.isBetween(start, end, null, '[]');
		},
		isValidDate(value) {
			return typeof value === 'string' && moment(value, 'YYYY-MM-DD', true).isValid();
		},
		formatAmount(value) {
			return Number(value || 0).toFixed(2);
		},
		// campi in sola lettura della card da telefono
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '' },
				{ label: 'Spedito', value: item.ShippedTime ? moment(item.ShippedTime).format('DD/MM/YYYY HH:mm:ss') : '' },
				{ label: 'Totale', value: this.formatAmount(item.Total), strong: true },
				{ label: 'Commissione', value: this.formatAmount(item.commission), strong: true },
			];
		},
		// torna alla dashboard nello stato in cui era (periodo, pagina, ricerca)
		goBack() {
			this.$router.push(listReturnLocation('/affiliate/dashboard')).catch(() => {});
		},
	},
	beforeDestroy() {
		this.$store.dispatch('partners/destroyData');
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.affiliate-order-cards,
.affiliate-order-cards tr {
	display: block;
	width: 100%;
}
.affiliate-order-cards tr,
.affiliate-order-cards tr:hover {
	background: transparent !important;
}
.affiliate-order-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.affiliate-order-cards tr:first-child td {
	padding-top: 12px !important;
}
.affiliate-order-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.affiliate-order-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
